/**
 * The commit SHA of the current build.
 * If the build is a local build, the value is 'local-build'.
 */
export const commitSha = import.meta.env.VITE_CI_COMMIT_SHA;
